import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Table, Input, Space, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import SearchIcon from "../../image/SearchIcon.svg";
import PropTypes from "prop-types";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { Link } from "react-router-dom";
import { debounce } from "lodash";
import { getRequest } from "../../axios";
import { authUserData } from "../../utils/Helper";
import { InfoCircleOutlined } from "@ant-design/icons";

const AssignedSiteEmployeeGrid = ({ prId }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { Search } = Input;
  const [selectedRow, setSelectedRow] = useState([]);
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [zoneList, setZoneList] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const CompanyID = authUserData()?.company ? authUserData()?.company : null;
  // const [zoneId, setZoneId] = useState(null);

  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
  });
  useEffect(() => {
    const getZoneList = async () => {
      setLoading(true);

      try {
        const fields = [
          "id",
          "approval_by_site",
          "city_name",
          "site_name",
          "pr_creator",
          "pr_creator_email",
          "pr_creator_phone",
          "pr_approval_by",
          "pr_approval_phone",
          "pr_approval_email",
          "pr_status",
          "pr_reject_reason",
          "pr_reject_by",
          "pr_sent_for_approval_date",
          "pr_approval_date",
          "approval_time",
        ].join(",");
        const queryParams = new URLSearchParams({
          ...state,
          fields,
        });
        let apiResponse = await getRequest(
          `purchase-requisition/${prId}/get-pr-approval-data-by-site/?${queryParams.toString()}`,
          state
        );
        if (apiResponse?.status) {
          setZoneList(apiResponse?.data?.data[0]?.approval_by_site);
          settotalCount(apiResponse?.data?.count);
        } else {
          ErrorNotificationMsg(t("error_in_company_adress_list"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getZoneList();
  }, [state, reload, t]);

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
    setSelectedRow(selectedRow);
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "pr_approval_by" && sortOrder === "ascend") {
      sortingEnumKey = "pr_approval_by__first_name";
    }
    if (sortField === "pr_approval_by" && sortOrder === "descend") {
      sortingEnumKey = "-pr_approval_by__first_name";
    }
    if (sortField === "site_name" && sortOrder === "ascend") {
      sortingEnumKey = "purchase_requisition_site__site_name__site_name";
    }
    if (sortField === "site_name" && sortOrder === "descend") {
      sortingEnumKey = "-purchase_requisition_site__site_name__site_name";
    }
    if (sortField === "pr_approval_date" && sortOrder === "ascend") {
      sortingEnumKey = "pr_approval_date";
    }
    if (sortField === "pr_approval_date" && sortOrder === "descend") {
      sortingEnumKey = "-pr_approval_date";
    }
    if (sortField === "pr_status" && sortOrder === "ascend") {
      sortingEnumKey = "pr_status";
    }
    if (sortField === "pr_status" && sortOrder === "descend") {
      sortingEnumKey = "-pr_status";
    }

    return sortingEnumKey;
  };

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };
  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const formatApprovalTime = (timeString) => {
    if (timeString === "0 Hrs 0 min 0 sec") {
      return "0 Hrs 0 min";
    } else {
      const timeParts = timeString?.match(
        /(\d+)\s*days?,?\s*(\d+)\s*hours?,?\s*(\d+)\s*minutes?,?\s*(\d+)\s*seconds?/
      );

      if (!timeParts) return "";

      const [_, days, hours, minutes, seconds] = timeParts.map(Number);

      // const formattedTime = `${hours ? hours + " hrs " : ""}${
      //   minutes ? minutes + " min " : ""
      // }`;
      // console.log("formattedTime", formattedTime.trim());
      // return formattedTime.trim();

      let formattedTime = "";

      if (hours) formattedTime += `${hours} hrs `;

      if (minutes) formattedTime += `${minutes} min `;

      if (!hours && !minutes && seconds) formattedTime += `${seconds} sec`;

      return formattedTime.trim();
    }
  };

  const columns = [
    {
      title: "City ",
      dataIndex: "city_name",
      key: "city_name",
      width: "150px",
      // sorter: true,
    },
    {
      title: "Site",
      dataIndex: "site_name",
      key: "site_name",
      width: "150px",
      // sorter: true,
    },
    {
      title: "PR Creator",
      dataIndex: "pr_creator",
      key: "pr_creator",
      sorter: true,
      // width: 150,
      render: (text, record) => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
              width: "max-content",
            }}
          >
            <p>{text} </p>
            <p style={{ marginTop: "4px" }}>
              <Tooltip
                color="#094E8F"
                placement="bottom"
                title={
                  <div
                    style={{
                      color: "white",
                      textAlign: "left",
                      padding: "8px 5px",
                    }}
                  >
                    <p style={{ margin: 0, color: "white" }}>
                      <strong>Email:</strong>{" "}
                      {record?.pr_creator_email
                        ? record?.pr_creator_email
                        : "N/A"}
                    </p>
                    <p style={{ margin: 0, color: "white" }}>
                      <strong>Mobile:</strong>{" "}
                      {record?.pr_creator_phone
                        ? record?.pr_creator_phone?.startsWith("91")
                          ? ` +91 ${record?.pr_creator_phone.slice(2)}`
                          : ` ${record?.pr_creator_phone}`
                        : " N/A"}
                    </p>
                  </div>
                }
              >
                <InfoCircleOutlined
                  style={{
                    color: "#094E8F",
                    marginLeft: "3px",
                    cursor: "pointer",
                  }}
                />
              </Tooltip>
            </p>
          </div>
        );
      },
    },
    {
      title: "Approver",
      dataIndex: "pr_approval_by",
      key: "pr_approval_by",
      width: "200px",
      render: (value, record) => {
        const displayName = value && value.trim() !== "" ? value : "Rejected";
        const email = record.pr_approval_email || "N/A";
        const phone = record.pr_approval_phone || "N/A";

        return (
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <span>{displayName}</span>
            {(email !== "N/A" || phone !== "N/A") && (
              <Tooltip
                color="#094E8F"
                placement="bottom"
                title={
                  <>
                    <div>Email: {email}</div>
                    <div>Phone: {phone}</div>
                  </>
                }
              >
                <InfoCircleOutlined
                  style={{
                    color: "#094E8F",
                    marginLeft: "3px",
                    cursor: "pointer",
                  }}
                />
              </Tooltip>
            )}
          </div>
        );
      },
    },

    // {
    //   title: "Role",
    //   dataIndex: "role",
    //   key: "role",
    //   width: 180,
    //   ellipsis: true,
    //   render: (text, record) => {
    //     const roleNames = record.pr_approval_by_role
    //       ?.filter((item) => item?.role_name)
    //       .map((item) => item.role_name)
    //       .join(", ");
    //     return (
    //       <div>
    //         <Tooltip color="#094E8F" title={roleNames} placement="topLeft">
    //           <span>{roleNames}</span>
    //         </Tooltip>
    //       </div>
    //     );
    //   },
    // },
    {
      title: "PR Status",
      dataIndex: "pr_status",
      key: "pr_status",
      sorter: true,
      render: (_, record) => {
        const isRejected = record.pr_status === "Reject With Reason";
        const rejectByName = record.pr_reject_by || "Unknown";

        return (
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {record.pr_status}
            {isRejected && record.pr_reject_reason && (
              <Tooltip
                title={
                  <>
                    <div>Reason: {record.pr_reject_reason}</div>
                    <div>Name: {rejectByName}</div>
                  </>
                }
              >
                <InfoCircleOutlined
                  style={{ color: "#faad14", cursor: "pointer" }}
                />
              </Tooltip>
            )}
          </span>
        );
      },
    },
    {
      title: "Sent For Approval",
      dataIndex: "pr_sent_for_approval_date",
      key: "pr_sent_for_approval_date",
      width: 180,
      // sorter: true,
    },
    {
      title: "Approved Date & Time",
      dataIndex: "pr_approval_date",
      key: "pr_approval_date",
      width: "200px",
    },
    {
      title: "Approval Time/Hrs",
      dataIndex: "approval_time",
      key: "approval_time",
      width: "200px",
      render: (text) => formatApprovalTime(text),
    },
  ];
  return (
    <>
      {/* <div className="tblheader mt-3"> */}
      <div className="secsubtitle">{t("PR Approval Status")}</div>

      <div>
        <Table
          scroll={{ x: 500 }}
          columns={columns}
          rowKey={(record) => record.id}
          dataSource={zoneList}
          loading={loading}
          // pagination={{
          //   current: state.page,
          //   pageSize: state.pagesize,
          //   total: totalCount,
          //   showTotal: (total) => `Total ${total} items`,
          //   showSizeChanger: false,
          // }}
          pagination={false}
          onChange={handleTableChange}
        />
      </div>
    </>
  );
};

AssignedSiteEmployeeGrid.propTypes = {
  prId: PropTypes.number,
};
export default AssignedSiteEmployeeGrid;
